@if (!modalData.hiddeHeader) {
<div class="modal-header border-bottom-0 py-1 d-flex justify-content-between">
  @if (modalData.title) {
  <h5 class="modal-title">{{ modalData.title }}</h5>
  }
  <span></span>
  <div>
    @if (modalData.showMaximize) {
    <button type="button" class="btn p-0 me-2" (click)="resize()">
      <i class="bi" [ngClass]="maximized ? 'bi-chevron-compact-down' : 'bi-square'"></i>
    </button>
    }
    <button type="button" class="btn p-0 px-1" (click)="activeModal.close()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
</div>
}
<div class="modal-body p-0">
  <ng-container #modalContent></ng-container>
</div>
@if (modalData.showButtons || modalData.confirmButton || modalData.cancelButton) {
<div class="modal-footer py-1 border-top-0">
  @if (modalData.showButtons || modalData.cancelButton) {
  <button type="button" class="btn btn-sm btn-outline-primary" (click)="activeModal.close()">
    {{ modalData.cancelButton || 'Cancelar'}}</button>
  }
  @if (modalData.showButtons || modalData.confirmButton) {
  <button type="button" class="btn btn-sm btn-primary" (click)="activeModal.close(outData)">
    {{modalData.confirmButton || 'Aceptar'}}</button>
  }
</div>
}